module.exports = __webpack_public_path__ + "static/media/model_result_neutral.8b5afb11.gif";